import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import { EditCategoryContext, IEditCategoryContext } from '../../../../editCategoryState/editCategoryContext';
import React, { useContext, useMemo } from 'react';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './EditForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
	vertical: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
};

interface IEditForm {
	isVisible: boolean;
}

const EditForm: React.FC<IEditForm> = ({ isVisible }) => {
	const { setFileId, deletePhoto, fileId, filePath, preSignedUrl, categoryID } =
		useContext<IEditCategoryContext>(EditCategoryContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const loadFromFilePathOptions = useMemo(
		() => ({
			filePath,
			preSignedUrl,
			entityID: categoryID,
		}),
		[filePath, preSignedUrl, categoryID],
	);

	return (
		<div className={containerClasses} data-test="EditForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				deletePhotoHandler={deletePhoto}
				setFileId={setFileId}
				horizontalAspectRatio={208 / 128}
				verticalAspectRatio={208 / 128}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};

export default EditForm;
